import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import CardProcessorOfferWrapper from "@components/layouts/cardProcessorOffersWrapper";
export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <CardProcessorOfferWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#01847f" />
                </div>
                <FormSection iconsFillColor="#01847f" />
            </div>
        </CardProcessorOfferWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
